export const SERVICE_PRIORITY_DM_CHECKOUT_FLOW = 'service_priority_dm';

export const DEFAULT_PRIORITY_DM_SLA_HOURS = 48;

export type PriorityDmIntakeQuestion = {
  id: string;
  question: string;
  required: boolean;
};

export function validatePriorityDmIntakeQuestions(questions: PriorityDmIntakeQuestion[]): string[] {
  const errors: string[] = [];
  if (questions.length > 10) errors.push('At most 10 intake questions allowed');
  for (const q of questions) {
    if (!q.question.trim()) errors.push('Each intake question needs text');
  }
  return errors;
}

export function validatePriorityDmOfferPublish(input: {
  title: string;
  priceCents: number;
  refundPolicyText?: string | null;
  slaHours: number;
  slaPublicCopy?: string | null;
}): { errors: string[]; warnings: string[] } {
  const errors: string[] = [];
  const warnings: string[] = [];

  if (!input.title.trim()) errors.push('Title is required');
  if (input.priceCents > 0 && !input.refundPolicyText?.trim()) {
    errors.push('Refund policy is required for paid offers');
  }
  if (input.slaHours < 1 || input.slaHours > 168) {
    errors.push('SLA must be between 1 and 168 hours');
  }
  if (!input.slaPublicCopy?.trim()) {
    warnings.push('Add public SLA copy so buyers know when to expect a response');
  }

  return { errors, warnings };
}

export function formatPriorityDmSlaCopy(slaHours: number): string {
  if (slaHours === 1) return 'Response within 1 hour';
  if (slaHours < 24) return `Response within ${slaHours} hours`;
  const days = Math.round(slaHours / 24);
  return days === 1 ? 'Response within 1 day' : `Response within ${days} days`;
}

export const SERVICE_PRIORITY_DM_ANALYTICS_EVENT = {
  SUBMITTED: 'priority_dm.submitted',
  FULFILLED: 'priority_dm.fulfilled',
} as const;
